import { PhoneNumberUtil } from "google-libphonenumber";

var InternationalPhoneNumUtil = function InternationalPhoneNumUtil($resource, $log) {
	return {
		formatToE164: formatToE164
	};

	function formatToE164(phoneNumber, countryCode) {
		var phoneUtil = PhoneNumberUtil.getInstance();
		try {
			var phoneNumber = phoneUtil.parse(phoneNumber, countryCode);

			return phoneUtil.format(phoneNumber, PNF.INTERNATIONAL);
		}
		catch (err) {
			console.log("error formatting the phone number with " + phoneNumber + ":country code: " + countryCode)
			return phoneNumber;
		}
	}
};

InternationalPhoneNumUtil.$inject = ['$resource', '$log'];
export default InternationalPhoneNumUtil;
